/**
 * This file is used to handle function calls in the application.
 */ var functionCallsHandler = function() {
    var functionCalls = [];
    /**
     * Add a function call to the function calls list
     * @param {string} functionName
     * @param {string} componentId
     * @returns {void}
     */ var addFunctionCall = function(functionName, componentId) {
        functionCalls.push({
            functionName: functionName,
            componentId: componentId
        });
    };
    /**
     * Check if a function call exists
     * @param {string} functionName
     * @param {string} componentId
     * @returns {boolean}
     */ var functionCallExists = function(functionName, componentId) {
        return functionCalls.some(function(fc) {
            return fc.functionName === functionName && fc.componentId === componentId;
        });
    };
    return {
        addFunctionCall: addFunctionCall,
        functionCallExists: functionCallExists
    };
};
export default functionCallsHandler;
